"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ART_SETS_LAYOUTS_NAMES = {
    SOLO_PORTRAIT: 'solo_portrait',
    SOLO_LANDSCAPE: 'solo_landscape',
    SOLO_SQUARE: 'solo_square',
    TWINS_LANDSCAPE: 'twins_landscape',
    TWINS_PORTRAIT: 'twins_portrait',
    TWINS_SQUARE: 'twins_square',
    TWO_TOWER: 'two_tower',
    TWO_STAIRWAY: 'two_stairway',
    TWO_MOLECULAR: 'two_molecular',
    TRIO_PORTRAIT: 'trio_portrait',
    TRIO_LANDSCAPE: 'trio_landscape',
    TRIO_SQUARE: 'trio_square',
    THREE_TOWER: 'three_tower',
    THREE_ORGANIC: 'three_organic',
    THREE_VERTICAL: 'three_vertical',
    THREE_STAIRWAY: 'three_stairway',
    THREE_BLOCKS: 'three_blocks',
    THREE_MOLECULAR: 'three_molecular',
    THREE_CLOUD: 'three_cloud',
    THREE_SPARSE: 'three_sparse',
    QUARTET_PORTRAIT: 'quartet_portrait',
    QUARTET_LANDSCAPE: 'quartet_landscape',
    QUARTET_SQUARE: 'quartet_square',
    FOUR_TOWER: 'four_tower',
    FOUR_STAIRWAY: 'four_stairway',
    FOUR_ORGANIC: 'four_organic',
    FOUR_VERTICAL: 'four_vertical',
    FOUR_GRID: 'four_grid',
    FOUR_BLOCKS: 'four_blocks',
    FOUR_MOLECULAR: 'four_molecular',
    FOUR_CLOUD: 'four_cloud',
    CINQUE_PORTRAIT: 'cinque_portrait',
    FIVE_TOWER: 'five_tower',
    FIVE_ORGANIC: 'five_organic',
    FIVE_VERTICAL: 'five_vertical',
    FIVE_STAIRWAY: 'five_stairway',
    FIVE_GRID: 'five_grid',
    FIVE_BLOCKS: 'five_blocks',
    FIVE_MOLECULAR: 'five_molecular',
    FIVE_CLOUD: 'five_cloud',
    FIVE_WAVE: 'five_wave',
    FIVE_SQUARE: 'five_square',
    GRID_PORTRAIT: 'grid_portrait',
    SIX_TOWER: 'six_tower',
    SIX_ORGANIC: 'six_organic',
    SIX_VERTICAL: 'six_vertical',
    SIX_STAIRWAY: 'six_stairway',
    SIX_BLOCKS: 'six_blocks',
    SIX_MOLECULAR: 'six_molecular',
    SIX_CLOUD: 'six_cloud',
    SIX_SPARSE: 'six_sparse',
    SIX_SQUARE: 'six_square',
    PYRAMID_PORTRAIT: 'pyramid_portrait',
    SEVEN_TOWER: 'seven_tower',
    SEVEN_ORGANIC: 'seven_organic',
    SEVEN_VERTICAL: 'seven_vertical',
    SEVEN_STAIRWAY: 'seven_stairway',
    SEVEN_GRID: 'seven_grid',
    SEVEN_BLOCKS: 'seven_blocks',
    SEVEN_MOLECULAR: 'seven_molecular',
    SEVEN_CLOUD: 'seven_cloud',
    SEVEN_SQUARE: 'seven_square',
    EIGHT_SQUARE: 'eight_square'
};
exports.default = ART_SETS_LAYOUTS_NAMES;
//# sourceMappingURL=art-layout-names.js.map